<template>
    <div>
        <button @click="test">test</button>
        <button @click="test1">test1</button>
        <button @click="test2">test2</button>
        <button @click="startSSE">Start SSE</button>
        <button @click="chatgpt">chatgpt</button>
        <!-- <div v-if="sseData">
            <p v-for="msg in sseData">{{ msg }}</p>
        </div> -->
        <p v-for="sseData in sseDatas">{{ sseData }}</p>

        <p>{{ sseString }}</p>
    </div>
</template>
  
<script>

import axios from 'axios'
import { ChatAPI } from '../../api/chat';


export default {
    name: 'SSEExample',
    components: {
    },
    data() {
        return {
            sseDatas: [],
            sseString: '',
            readLineIndex: 0
        }
    },
    methods: {
        startSSE() {
            const source = new EventSource('https://laicj.cn/api/chat/sse/test?id=1')

            // Set the timeout to 120 seconds
            source.timeout = 120000

            source.addEventListener('message', (event) => {
                console.log('Received message:', event.data)
            })

            source.addEventListener('open', (event) => {
                console.log('Connection opened')
            })

            source.addEventListener('error', (event) => {
                console.log('Error occurred:', event)
            })

            source.onmessage = (event) => {
                // this.sseData.push(event.data)
                var tmp = event.data === '' ? '\n' : event.data
                console.info(tmp)
                this.sseString += tmp
                this.sseDatas.push(tmp)
                console.log(event)
                if (event.date === 'Done') {
                    console.info("Done")
                    source.close()
                }
            }

            // Handle SSE connection errors
            source.onerror = (error) => {
                console.info("error")
                source.close()
            }
        },
        startSSEPost() {
            axios({
                // method: 'post',
                url: 'https://laicj.cn/api/chat/sse/test1',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'text/event-stream',
                },
                responseType: 'text',
                timeout: 0, // Set timeout to 0 to disable it
                onDownloadProgress: (progressEvent) => {
                    const data = progressEvent.event.currentTarget.response

                    // Split the data into lines
                    const lines = data.trim().split('\n')

                    // Process each line of data
                    lines.forEach((line) => {
                        console.log("line: " + line)
                        // Extract the event type and data from the line
                        const [eventType, eventData] = line.split(':')

                        // Update the component state with the new data
                        if (eventType === 'data') {
                            this.sseData = eventData.trim()
                        }
                    })
                },
            })
        },
        chatgpt() {
            axios({
                method: 'post',
                url: 'https://api.openai.com/v1/chat/completions',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'text/event-stream',
                    "authorization": "Bearer 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"
                },
                data: {
                    "model": "gpt-3.5-turbo",
                    "messages": [{ "role": "user", "content": "写一副对联" }]
                },
                responseType: 'text',
                onDownloadProgress: (progressEvent) => {
                    const data = progressEvent.event.currentTarget.response

                    // Split the data into lines
                    const lines = data.trim().split('\n')

                    // Process each line of data
                    lines.forEach((line) => {
                        console.log("line: " + line)
                        // Extract the event type and data from the line
                        const [eventType, eventData] = line.split(':')

                        // Update the component state with the new data
                        if (eventType === 'data') {
                            this.sseData = eventData.trim()
                        }
                    })
                },
            })
        },
        test() {
            ChatAPI.chatStream({}, (tmp => {
                console.log(tmp)
                this.sseString = tmp
            }))
        },
        test1() {
            const data = {content:"你好"}
            axios({
                method: 'post',
                url: 'https://laicj.cn/api/chat/sse/test1',
                data,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'text/event-stream',
                },
                onDownloadProgress: (progressEvent) => {
                    var response = progressEvent.event.target.responseText
                    console.info(response)
                    this.sseString = response
                },
            })
        },
        test2() {
            const data = {content:"你好"}
            axios({
                method: 'post',
                data,
                url: 'https://laicj.cn/api/chat/stream/test',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'text/event-stream',
                },
                responseType: 'text',
                timeout: 0, // Set timeout to 0 to disable it
                onDownloadProgress: (progressEvent) => {
                    var response = progressEvent.event.target.responseText
                    console.info(response)
                    this.sseString = response
                }
            })
        },

    },
}
</script>
  


// WEBPACK FOOTER //
// src/components/test/SSEExample.vue